/* KitKraft — "Sort or Short". Components fall; tap the bin each one belongs in
   (Boards / Sensors / Outputs / Power) before it lands. 3 wrong-or-missed = over.
   No requestAnimationFrame — the fall is a CSS transition, a 180ms tick drives
   the rest. Touch + click + number keys 1–4. */
(function () {
  "use strict";

  var IC = {
    board: '<svg viewBox="0 0 40 40"><rect x="6" y="9" width="28" height="22" rx="3" fill="#1f6fd6" stroke="#0d3f80" stroke-width="2"/><rect x="10" y="13" width="9" height="9" rx="1" fill="#0d3f80"/><rect x="6" y="12" width="3" height="2" fill="#ffd24a"/><rect x="6" y="17" width="3" height="2" fill="#ffd24a"/><rect x="6" y="22" width="3" height="2" fill="#ffd24a"/><rect x="31" y="12" width="3" height="2" fill="#ffd24a"/><rect x="31" y="22" width="3" height="2" fill="#ffd24a"/></svg>',
    pi: '<svg viewBox="0 0 40 40"><rect x="6" y="8" width="28" height="24" rx="3" fill="#2a7a3f" stroke="#12451f" stroke-width="2"/><rect x="9" y="10" width="22" height="3" fill="#ffd24a"/><circle cx="13" cy="20" r="3" fill="#12451f"/><circle cx="22" cy="20" r="3" fill="#c0c0c0"/><rect x="26" y="24" width="6" height="5" fill="#333"/></svg>',
    sensorU: '<svg viewBox="0 0 40 40"><rect x="5" y="14" width="30" height="12" rx="2" fill="#1b7fb0" stroke="#0c4763" stroke-width="2"/><circle cx="14" cy="20" r="6" fill="#2a2a2a" stroke="#0c4763" stroke-width="2"/><circle cx="26" cy="20" r="6" fill="#2a2a2a" stroke="#0c4763" stroke-width="2"/></svg>',
    sensorP: '<svg viewBox="0 0 40 40"><circle cx="20" cy="20" r="13" fill="#e9e9e9" stroke="#8a8a8a" stroke-width="2"/><circle cx="20" cy="20" r="8" fill="#d8d8d8"/><rect x="17" y="31" width="6" height="4" fill="#1b7fb0"/></svg>',
    sensorD: '<svg viewBox="0 0 40 40"><rect x="10" y="8" width="20" height="24" rx="2" fill="#5aa9e0" stroke="#0c4763" stroke-width="2"/><rect x="14" y="12" width="12" height="7" fill="#0c4763"/><rect x="15" y="32" width="2" height="4" fill="#ffd24a"/><rect x="19" y="32" width="2" height="4" fill="#ffd24a"/><rect x="23" y="32" width="2" height="4" fill="#ffd24a"/></svg>',
    servo: '<svg viewBox="0 0 40 40"><rect x="10" y="12" width="20" height="20" rx="2" fill="#2f6bff" stroke="#123a99" stroke-width="2"/><rect x="6" y="16" width="4" height="12" fill="#2f6bff"/><rect x="30" y="16" width="4" height="12" fill="#2f6bff"/><rect x="18" y="4" width="4" height="10" rx="2" fill="#e0e0e0" stroke="#123a99" stroke-width="1.5"/><circle cx="20" cy="14" r="3" fill="#123a99"/></svg>',
    motor: '<svg viewBox="0 0 40 40"><rect x="9" y="12" width="20" height="16" rx="8" fill="#b8b8b8" stroke="#6a6a6a" stroke-width="2"/><rect x="29" y="17" width="7" height="6" fill="#8a8a8a"/><rect x="4" y="15" width="5" height="3" fill="#c9772f"/><rect x="4" y="22" width="5" height="3" fill="#c9772f"/></svg>',
    buzzer: '<svg viewBox="0 0 40 40"><circle cx="20" cy="18" r="12" fill="#1a1a1a" stroke="#000" stroke-width="2"/><circle cx="20" cy="18" r="3" fill="#444"/><rect x="17" y="30" width="2" height="6" fill="#c0c0c0"/><rect x="21" y="30" width="2" height="6" fill="#c0c0c0"/></svg>',
    led: '<svg viewBox="0 0 40 40"><path d="M20 6c6 0 9 5 9 10 0 4-2 6-2 9H13c0-3-2-5-2-9 0-5 3-10 9-10z" fill="#ff5a5f" stroke="#a52a2e" stroke-width="2"/><rect x="15" y="30" width="2" height="6" fill="#c0c0c0"/><rect x="23" y="30" width="2" height="6" fill="#c0c0c0"/></svg>',
    relay: '<svg viewBox="0 0 40 40"><rect x="8" y="10" width="24" height="20" rx="2" fill="#1f7fd6" stroke="#0d3f80" stroke-width="2"/><rect x="11" y="13" width="18" height="9" rx="1" fill="#0d3f80"/><rect x="12" y="30" width="3" height="5" fill="#ffd24a"/><rect x="25" y="30" width="3" height="5" fill="#ffd24a"/></svg>',
    oled: '<svg viewBox="0 0 40 40"><rect x="7" y="11" width="26" height="18" rx="2" fill="#111" stroke="#3a5a8a" stroke-width="2"/><rect x="10" y="14" width="20" height="10" fill="#0a3a6a"/><rect x="12" y="16" width="14" height="2" fill="#4fa3ff"/><rect x="12" y="20" width="9" height="2" fill="#4fa3ff"/></svg>',
    battery: '<svg viewBox="0 0 40 40"><rect x="8" y="12" width="24" height="16" rx="3" fill="#3ecf8e" stroke="#1c7a52" stroke-width="2"/><rect x="32" y="17" width="4" height="6" rx="1" fill="#1c7a52"/><text x="14" y="24" font-family="monospace" font-size="9" font-weight="700" fill="#0c3a26">+</text><text x="23" y="24" font-family="monospace" font-size="10" font-weight="700" fill="#0c3a26">-</text></svg>',
    battery9v: '<svg viewBox="0 0 40 40"><rect x="12" y="8" width="16" height="24" rx="2" fill="#222" stroke="#000" stroke-width="2"/><circle cx="17" cy="8" r="3" fill="#c9772f"/><circle cx="23" cy="8" r="3" fill="#c0c0c0"/><text x="14" y="24" font-family="monospace" font-size="8" font-weight="700" fill="#3ecf8e">9V</text></svg>',
    buck: '<svg viewBox="0 0 40 40"><rect x="6" y="12" width="28" height="16" rx="2" fill="#3a8a5a" stroke="#1c5537" stroke-width="2"/><circle cx="14" cy="20" r="4" fill="#c9a227"/><rect x="22" y="15" width="9" height="10" fill="#1c5537"/><rect x="7" y="16" width="3" height="2" fill="#ffd24a"/><rect x="7" y="22" width="3" height="2" fill="#ffd24a"/></svg>'
  };

  var PARTS = [
    { n: "Arduino Uno", c: "boards", i: "board" },
    { n: "Arduino Nano", c: "boards", i: "board" },
    { n: "ESP32", c: "boards", i: "board" },
    { n: "NodeMCU", c: "boards", i: "board" },
    { n: "Raspberry Pi", c: "boards", i: "pi" },
    { n: "HC-SR04", c: "sensors", i: "sensorU" },
    { n: "PIR Motion", c: "sensors", i: "sensorP" },
    { n: "DHT11", c: "sensors", i: "sensorD" },
    { n: "LDR module", c: "sensors", i: "sensorP" },
    { n: "IR Sensor", c: "sensors", i: "sensorD" },
    { n: "Soil Moisture", c: "sensors", i: "sensorD" },
    { n: "SG90 Servo", c: "outputs", i: "servo" },
    { n: "DC Motor", c: "outputs", i: "motor" },
    { n: "Buzzer", c: "outputs", i: "buzzer" },
    { n: "LED", c: "outputs", i: "led" },
    { n: "Relay Module", c: "outputs", i: "relay" },
    { n: "OLED Display", c: "outputs", i: "oled" },
    { n: "Battery Holder", c: "power", i: "battery" },
    { n: "9V Battery", c: "power", i: "battery9v" },
    { n: "Buck Converter", c: "power", i: "buck" },
    { n: "Li-ion Cell", c: "power", i: "battery" }
  ];

  var BINS = [
    { c: "boards", label: "Boards", i: "board" },
    { c: "sensors", label: "Sensors", i: "sensorP" },
    { c: "outputs", label: "Outputs", i: "servo" },
    { c: "power", label: "Power", i: "battery" }
  ];

  var TARGET = 20;

  function initOne(root) {
    if (root.dataset.kksInit) return;
    root.dataset.kksInit = "1";

    var stage = root.querySelector("[data-kks-stage]");
    var binsWrap = root.querySelector("[data-kks-bins]");
    var scoreEl = root.querySelector("[data-kks-score]");
    var livesEl = root.querySelector("[data-kks-lives]");
    var toastEl = root.querySelector("[data-kks-toast]");
    var legendEl = root.querySelector("[data-kks-legend]");
    var startBtn = root.querySelector("[data-kks-start]");
    var overH = root.querySelector("[data-kks-over-h]");
    var overP = root.querySelector("[data-kks-over-p]");
    var overRetry = root.querySelector("[data-kks-over-retry]");
    var overCta = root.querySelector("[data-kks-over-cta]");

    // Defensive guard: a real session hit "Cannot read properties of null
    // (reading 'innerHTML')" on this page (Clarity, 2026-09-14/15) that couldn't
    // be reproduced live despite many attempts (different viewports, referrer
    // paths, click-vs-URL navigation). Rather than crash the whole page's script
    // execution if any of this game's expected elements are ever missing (a
    // markup edit, a caching quirk, a browser extension mutating the DOM, etc.),
    // bail out of just this game's init cleanly.
    if (!stage || !binsWrap || !scoreEl || !livesEl || !toastEl || !legendEl ||
        !startBtn || !overH || !overP || !overRetry || !overCta) return;

    overCta.textContent = root.getAttribute("data-cta-label") || "See the parts";
    overCta.setAttribute("href", root.getAttribute("data-cta-href") || "#");

    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var comps = [], score = 0, lives = 3, lvl = 0, playing = false;
    var spawnT = 0, tickT = 0;

    // build bins
    binsWrap.innerHTML = "";
    BINS.forEach(function (b, k) {
      var el = document.createElement("button");
      el.type = "button";
      el.className = "kksort__bin b-" + b.c;
      el.innerHTML = IC[b.i] + '<span class="bl">' + b.label + "</span>";
      el.addEventListener("click", function () { sortInto(b.c, el); });
      binsWrap.appendChild(el);
      b._el = el;
    });
    legendEl.innerHTML =
      'Boards: Uno, Nano, ESP32, Pi &nbsp;·&nbsp; Sensors: HC-SR04, PIR, DHT11, LDR<br>' +
      'Outputs: servo, motor, buzzer, LED, relay, OLED &nbsp;·&nbsp; Power: battery, buck, 9V';

    document.addEventListener("keydown", function (e) {
      if (!playing) return;
      var idx = "1234".indexOf(e.key);
      if (idx >= 0) sortInto(BINS[idx].c, BINS[idx]._el);
    });

    function stageH() { return stage.clientHeight || 300; }
    function fallDur() { return Math.max(5.6 - lvl * 0.5, 2.9); }
    function spawnGap() { return Math.max(1750 - lvl * 170, 850); }

    function spawn() {
      if (!playing) return;
      var p = PARTS[Math.floor(Math.random() * PARTS.length)];
      var el = document.createElement("div");
      el.className = "kksort__comp";
      el.dataset.cat = p.c;
      el.innerHTML = IC[p.i] + '<span class="nm">' + p.n + "</span>";
      var x = 8 + Math.random() * (stage.clientWidth - 90);
      el.style.transform = "translate(" + x + "px, -56px)";
      stage.appendChild(el);
      el._x = x; el._sorted = false;
      comps.push(el);
      // kick off the fall (setTimeout, not rAF — preview pane may not run rAF)
      var dur = fallDur();
      el._land = Date.now() + dur * 1000 + 60;
      setTimeout(function () {
        if (!el.parentNode || el._sorted) return;
        el.style.transition = "transform " + dur + "s linear";
        el.style.transform = "translate(" + x + "px, " + (stageH() + 40) + "px)";
      }, 40);
      el.addEventListener("transitionend", function () {
        if (!el._sorted) land(el);
      });
      spawnT = setTimeout(spawn, spawnGap());
    }

    function compY(el) {
      var s = stage.getBoundingClientRect(), r = el.getBoundingClientRect();
      return r.top + r.height / 2 - s.top;
    }

    function tick() {
      if (!playing) return;
      // mark the lowest un-sorted comp as active
      var low = null, ly = -1e9;
      comps.slice().forEach(function (c) {
        if (c._sorted) return;
        var y = compY(c);
        if (y > ly) { ly = y; low = c; }
        // safety: landed but transitionend never fired (or rAF/transition stalled)
        if ((y > stageH() + 18 || (c._land && Date.now() > c._land)) && !c._sorted) land(c);
      });
      comps.forEach(function (c) { c.classList.toggle("active", c === low); });
      tickT = setTimeout(tick, 160);
    }

    function activeComp() {
      var low = null, ly = -1e9;
      comps.forEach(function (c) {
        if (c._sorted || !c.parentNode) return;
        var y = compY(c);
        if (y > ly) { ly = y; low = c; }
      });
      return low;
    }

    function sortInto(cat, binEl) {
      if (!playing) return;
      var el = activeComp();
      if (!el) return;
      if (el.dataset.cat === cat) {
        el._sorted = true;
        el.classList.remove("active");
        // zip to the bin
        var s = stage.getBoundingClientRect(), b = binEl.getBoundingClientRect();
        var tx = b.left + b.width / 2 - s.left - 37;
        var ty = b.top - s.top - 20;
        el.style.transition = "transform .26s cubic-bezier(.4,0,.2,1), opacity .26s";
        el.classList.add("zip");
        el.style.transform = "translate(" + tx + "px," + ty + "px) scale(.4)";
        binEl.classList.remove("hit"); void binEl.offsetWidth; binEl.classList.add("hit");
        setTimeout(function () { remove(el); }, 300);
        score++;
        scoreEl.innerHTML = "sorted <b>" + score + "</b>";
        if (score % 5 === 0) lvl++;
        if (score === 8) toast("Nice!");
        else if (score === 14) toast("On a roll!");
        if (score >= TARGET) return win();
      } else {
        el.classList.remove("wrong"); void el.offsetWidth; el.classList.add("wrong");
        binEl.classList.remove("miss"); void binEl.offsetWidth; binEl.classList.add("miss");
        loseLife();
      }
    }

    function land(el) {
      if (el._sorted) return;
      el._sorted = true;
      remove(el);
      loseLife();
    }

    function remove(el) {
      var k = comps.indexOf(el);
      if (k >= 0) comps.splice(k, 1);
      if (el.parentNode) el.parentNode.removeChild(el);
    }

    function loseLife() {
      lives--;
      Array.prototype.forEach.call(livesEl.children, function (c, i) { c.classList.toggle("gone", i >= lives); });
      root.classList.remove("shake"); void root.offsetWidth; root.classList.add("shake");
      setTimeout(function () { root.classList.remove("shake"); }, 360);
      if (lives <= 0) gameOver();
    }

    function toast(txt) {
      toastEl.textContent = txt;
      toastEl.classList.remove("show"); void toastEl.offsetWidth; toastEl.classList.add("show");
    }

    function stop() {
      playing = false;
      clearTimeout(spawnT); clearTimeout(tickT);
      comps.slice().forEach(remove);
    }

    function gameOver() {
      stop();
      root.classList.add("is-over");
      overH.textContent = score >= 12 ? "Solid sorting! 🔧" : "Board short! ⚡";
      overP.textContent = "You sorted " + score + ". Those four bins are four real shelves in the parts room — that's where a build starts.";
      overRetry.hidden = false; overCta.hidden = false;
    }

    function win() {
      stop();
      root.classList.add("is-over");
      overH.textContent = "You've got the parts down! 🔧";
      overP.textContent = "Boards, sensors, outputs, power — sorted " + score + " without three mistakes. Now go pick the real ones.";
      overRetry.hidden = false; overCta.hidden = false;
      try { document.dispatchEvent(new CustomEvent("kk:game-won", { detail: { game: "sort-short" } })); } catch (e) {}
    }

    var started = false;
    function begin() {
      if (!started) {
        started = true;
        try { document.dispatchEvent(new CustomEvent("kk:game-start", { detail: { game: "sort-short" } })); } catch (e) {}
      }
      root.classList.remove("is-intro", "is-over");
      stop();
      comps = []; score = 0; lives = 3; lvl = 0; playing = true;
      scoreEl.innerHTML = "sorted <b>0</b>";
      Array.prototype.forEach.call(livesEl.children, function (c) { c.classList.remove("gone"); });
      spawnT = setTimeout(spawn, 650);
      tick();
    }

    startBtn.addEventListener("click", begin);
    overRetry.addEventListener("click", begin);

    root.classList.add("is-intro");
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll(".kksort[data-kks]"), initOne);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  window.KKSortShort = { init: boot };
})();
